module.exports = __webpack_public_path__ + "static/media/lilla_pile.84419ec3.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/img/lilla_pile.png
// module id = 1478
// module chunks = 0